import React, { useEffect } from 'react'
import * as d3 from 'd3'
import { useElementSize } from '../hooks'

export const TreeMap = ({ data }: { data: ITreeMapData }) => {
  const [ref, width, height] = useElementSize()

  useEffect(() => {
    if (!ref.current || !width || !height) { return }

    const svg = d3.select(ref.current)
    const root = d3.hierarchy(data).sum((d => d.value || 0))
    d3.treemap().size([width, height]).padding(0)(root)
    const group = svg.selectAll('g.wrapper')

    group.selectAll('rect')
      .data(root.leaves())
      .enter()
      .append('rect')
      .attr('x', (d: any) => d.x0)
      .attr('y', (d: any) => d.y0)
      .attr('width', (d: any) => d.x1 - d.x0)
      .attr('height', (d: any) => d.y1 - d.y0)
      .style('stroke', 'black')
      .style('fill', 'slateblue')

    group.selectAll('text')
      .data(root.leaves())
      .enter()
      .append('text')
      .attr('x', (d: any) => d.x0 + 5)
      .attr('y', (d: any) => d.y0 + 20)
      .text((d) => d.data.label)
      .attr('font-size', '15px')
      .attr('fill', 'white')

  }, [data, width, height])

  return <svg ref={ref} style={{ width: '100%', height: '100%' }}>
    <g className="wrapper" />
  </svg>
}

export interface ITreeMapData {
  label: string
  children?: ITreeMapData[]
  value?: number
}
